(function () {
  'use strict';

  var SELECTORS = {
    anchor:    '#jpr-anchor',
    revWidg:   '.jpr-widget',
    starBadge: '.jdgm-prev-badge__stars',
  };

  var API_BASE = 'https://api.judge.me/reviews/reviews_for_widget';

  // Same path as snippets/icon.liquid 'star-rating' / 'star-rating-empty'
  var STAR_PATH = 'm6.5 0 1.607 4.623 4.893.1-3.9 2.956 1.417 4.685L6.5 9.568l-4.017 2.796L3.9 7.679 0 4.723l4.893-.1L6.5 0Z';

  var LABELS = {
    verifiedBuyer:  'Achat vérifié',
    prev:           'Précédent',
    next:           'Suivant',
  };

  // ── Helpers ──────────────────────────────────────────────────────────────────

  function _esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function _formatDate(iso) {
    try {
      return new Date(iso).toLocaleDateString('fr-FR', {
        year: 'numeric', month: 'long', day: 'numeric',
      });
    } catch (e) { return ''; }
  }

  // ── Rendering ─────────────────────────────────────────────────────────────────

  function _renderStars(rating) {
    var starsHtml = '';
    for (var i = 1; i <= 5; i++) {
      var opacityAttr = i <= rating ? '' : ' fill-opacity="0.4"';
      starsHtml +=
        '<svg aria-hidden="true" focusable="false" width="10" viewBox="0 0 13 13">' +
          '<path fill="currentColor"' + opacityAttr + ' d="' + STAR_PATH + '"/>' +
        '</svg>';
    }
    return (
      '<div class="testimonial-card__rating h-stack gap-3">' +
        '<div class="h-stack gap-0.5">' + starsHtml + '</div>' +
        '<span>' + rating + '/5</span>' +
      '</div>'
    );
  }

  function _buildCard(review) {
    var date     = _formatDate(review.created_at);
    var dateHtml = date ? '<span class="jpr-card__date">' + date + '</span>' : '';
    var verified = review.verified_buyer
      ? '<span class="jpr-card__verified">' + LABELS.verifiedBuyer + '</span>'
      : '';
    var metaHtml = (dateHtml || verified)
      ? '<div class="jpr-card__meta">' + dateHtml + verified + '</div>'
      : '';

    return (
      '<article class="testimonial-card jpr-card">' +
        _renderStars(review.rating) +
        '<p class="testimonial-card__author">' + _esc(review.reviewer_name || '') + '</p>' +
        '<div class="testimonial-card__text">' + (review.body_html || '') + '</div>' +
        metaHtml +
      '</article>'
    );
  }

  // ── Slider ────────────────────────────────────────────────────────────────────

  function _buildSlider(reviews) {
    var slides = reviews.map(function (review) {
      return '<div class="jpr-slide">' + _buildCard(review) + '</div>';
    }).join('');

    return (
      '<div class="jpr-slider-wrapper">' +
        '<div class="jpr-slider" role="list">' + slides + '</div>' +
        '<button type="button" class="jpr-slider__btn jpr-slider__btn--prev" aria-label="' + LABELS.prev + '">&#8249;</button>' +
        '<button type="button" class="jpr-slider__btn jpr-slider__btn--next" aria-label="' + LABELS.next + '">&#8250;</button>' +
      '</div>'
    );
  }

  function _initSlider(wrapper) {
    var slider  = wrapper.querySelector('.jpr-slider');
    var prevBtn = wrapper.querySelector('.jpr-slider__btn--prev');
    var nextBtn = wrapper.querySelector('.jpr-slider__btn--next');
    if (!slider || !prevBtn || !nextBtn) return;

    function _scrollAmount() {
      var slide = slider.querySelector('.jpr-slide');
      return slide ? slide.offsetWidth + 16 : slider.clientWidth;
    }

    function _update() {
      var hasOverflow = slider.scrollWidth > slider.clientWidth + 1;
      wrapper.classList.toggle('jpr-slider--scrollable', hasOverflow);
      prevBtn.disabled = slider.scrollLeft <= 1;
      nextBtn.disabled = slider.scrollLeft >= slider.scrollWidth - slider.clientWidth - 1;
    }

    prevBtn.addEventListener('click', function () {
      slider.scrollBy({ left: -_scrollAmount(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      slider.scrollBy({ left: _scrollAmount(), behavior: 'smooth' });
    });
    slider.addEventListener('scroll', _update, { passive: true });
    window.addEventListener('resize', _update, { passive: true });
    // Defer initial check — browser needs one paint to calculate flex/percentage widths
    window.requestAnimationFrame(_update);
  }

  // ── Fetch ─────────────────────────────────────────────────────────────────────

  function _fetchAndRender(widg) {
    var productId  = widg.dataset.id;
    var shopDomain = widg.dataset.shopDomain;
    var sortKey    = widg.dataset.sortKey || 'date';
    var isMobile   = window.innerWidth < 700;
    var perPage    = isMobile
      ? (parseInt(widg.dataset.perPageMobile, 10) || 4)
      : (parseInt(widg.dataset.perPage, 10) || 6);
    if (!productId || !shopDomain) return;

    widg.classList.add('jpr--loading');

    // Always fetch by date — sort_key=rating not supported by API; sort applied client-side
    var url = API_BASE +
      '?shop_domain=' + encodeURIComponent(shopDomain) +
      '&product_id='  + encodeURIComponent(productId) +
      '&platform=shopify' +
      '&per_page='    + perPage +
      '&sort_key=date';

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        widg.classList.remove('jpr--loading');
        if (!data.reviews || !data.reviews.length) {
          var section = widg.closest('.shopify-section');
          if (section) section.style.display = 'none';
          return;
        }
        var reviews = data.reviews;
        if (sortKey === 'rating') {
          reviews = reviews.slice().sort(function (a, b) { return b.rating - a.rating; });
        }
        widg.insertAdjacentHTML('beforeend', _buildSlider(reviews));
        _initSlider(widg.querySelector('.jpr-slider-wrapper'));
      })
      .catch(function () { widg.classList.remove('jpr--loading'); });
  }

  // ── Init ──────────────────────────────────────────────────────────────────────

  function _initWidget() {
    var widg = document.querySelector(SELECTORS.revWidg);
    if (!widg || !widg.dataset.id || !widg.dataset.shopDomain) return;
    _fetchAndRender(widg);
  }

  /**
   * When the Judge.me star badge is clicked, smooth-scroll to the reviews
   * anchor on the same page — never navigate away.
   */
  function _initStarClick() {
    document.addEventListener('click', function (e) {
      var badge = e.target.closest(SELECTORS.starBadge);
      if (!badge) return;
      e.preventDefault();
      var anchor = document.querySelector(SELECTORS.anchor);
      if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function _boot() {
    _initWidget();
    _initStarClick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _boot);
  } else {
    _boot();
  }
})();
